export default __webpack_public_path__ + "static/magdalenab-bd1b8c281f8c0b6b07a3652d1fc0053e.jpg";